import worksbg from "../assets/images/hero-bg.jpg";
import { Button, Container, Row, Col, Modal, Tab, Tabs } from "react-bootstrap";
import Card3DHover from '../components/Card3DHover';
import { useState, useEffect } from 'react';
import ourWorksData from '../config/ourWorksData';

// Import floating icons
import saturn from '../assets/images/saturn.svg';
import gallaxy from '../assets/images/gallaxy.svg';
import rocketIcon from '../assets/images/rocket-icon.svg';
import moon from '../assets/images/moon.svg';
import dna from '../assets/images/dna.svg';
import atoms from '../assets/images/atoms.svg';
import atom from '../assets/images/atom.svg';
import rover from '../assets/images/rover.svg';

// Icon mapping
const iconMap = {
    saturn,
    gallaxy,
    rocketIcon,
    moon,
    dna,
    atoms,
    atom,
    rover
};

const OurWorks = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedWork, setSelectedWork] = useState(null);
    
    // Load Instagram embed script
    useEffect(() => {
        // Check if script already exists
        const existingScript = document.querySelector('script[src="https://www.instagram.com/embed.js"]');
        
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
            script.defer = true;
            script.onload = () => {
                // Script loaded, process any existing embeds
                if (window.instgrm && window.instgrm.Embeds) {
                    window.instgrm.Embeds.process();
                }
            };
            document.body.appendChild(script);
        } else if (window.instgrm && window.instgrm.Embeds) {
            // Script already exists, process embeds
            window.instgrm.Embeds.process();
        }
    }, []);

    // Re-initialize Instagram embeds when modal opens or posts change
    useEffect(() => {
        if (showModal && selectedWork?.modalContent?.instagramPosts?.length > 0) {
            // Wait for DOM to render and script to be ready
            const processEmbeds = () => {
                if (window.instgrm && window.instgrm.Embeds) {
                    try {
                        window.instgrm.Embeds.process();
                    } catch (error) {
                        console.error('Error processing Instagram embeds:', error);
                    }
                } else {
                    // Retry if script not loaded yet
                    setTimeout(processEmbeds, 200);
                }
            };
            
            // Wait for tab content to render
            const timer = setTimeout(() => {
                processEmbeds();
            }, 800);
            
            return () => clearTimeout(timer);
        }
    }, [showModal, selectedWork]);

    const handleOpenModal = (work) => {
        setSelectedWork(work);
        setShowModal(true);
    };
    
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedWork(null);
    };

    return (
        <div className="overflow-hidden">
            {/* Hero Section */}
            <div
                className="service-section-bg"
                style={{ backgroundImage: `url(${worksbg})` }}
            >
                <div className='service-overlay position-relative text-center'>
                    <h1 className='serive-page-title'>
                        Some of <span className="outline-theme-text">Finest</span> Work <br></br> we Done
                    </h1>


                </div>
            </div>


            {/* Loop through categories */}
            {ourWorksData.map((category) => (
                <div key={category.id} className="position-relative">
                    {/* Floating Icons */}
                    {category.floatingIcons.left && (
                        <img 
                            src={iconMap[category.floatingIcons.left]} 
                            alt='floating-icons' 
                            className={`floating-icons left ${category.floatingIcons.leftClass || ''}`} 
                        />
                    )}
                    {category.floatingIcons.right && (
                        <img 
                            src={iconMap[category.floatingIcons.right]} 
                            alt='floating-icons' 
                            className={`floating-icons right ${category.floatingIcons.position || ''} ${category.floatingIcons.rightClass || ''}`} 
                        />
                    )}

                    <Container className='mb-5 pb-5'>
                        <h1 
                            className="outline-text testimonials-section-title custom-size"
                            dangerouslySetInnerHTML={{ __html: category.categoryTitle }}
                        />

                        <Row>
                            {category.works.map((work) => (
                                <Col key={work.id} lg={4} md={6}>
                                    <Card3DHover>
                                        <div 
                                            className='client-card' 
                                            onClick={() => work.hasModal && handleOpenModal(work)}
                                            style={work.hasModal ? { cursor: 'pointer' } : {}}
                                        >
                                            <div className="image-wrapper">
                                                <img src={work.logo} alt={`${work.title}-logo`} className="client-logo" />
                                            </div>
                                            <div className='text-wrapper pt-4'>
                                                <h2>{work.title}</h2>
                                                <p>{work.description}</p>
                                            </div>
                                        </div>
                                    </Card3DHover>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
            ))}


            {/* Apply Modal */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                centered
                className="apply-modal"
                backdropClassName="glass-backdrop"
            >
                <Modal.Body className="p-0 contact-page modal-dark-bg" style={{ borderRadius: 20, overflow: 'hidden' }}>
                    <Row className="g-0">

                        <Col md={12} className="p-4">
                            <div>
                                <Button
                                    variant="link"
                                    className="ms-auto d-block text-white p-0"
                                    onClick={handleCloseModal}
                                    style={{ fontSize: "22px", textDecoration: "none" }}
                                >
                                    <i className="fa-solid fa-xmark"></i>
                                </Button>
                            </div>

                            <div className='contact-form-section'>
                                {selectedWork && selectedWork.modalContent && (
                                    <div>
                                        <div className="modal-logo-wrapper">
                                            <img src={selectedWork.logo} alt={`${selectedWork.title}-logo`} className="modal-client-logo" />
                                        </div>
                                        <div className='text-wrapper'>
                                            <p className="text-white">{selectedWork.modalContent.description}</p>
                                        </div>

                                        <Tabs
                                            defaultActiveKey="Photos"
                                            className="client-tabs"
                                        >
                                            <Tab eventKey="Photos" title="Photos">
                                                <Row>
                                                    {selectedWork.modalContent.photos.map((photo, index) => (
                                                        <Col key={index} md={4} className="mb-2 px-1">
                                                            <div className="our-work-image" style={{ backgroundImage: `url(${photo})` }}></div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="Videos" title="Videos">
                                                {selectedWork.modalContent.instagramPosts && selectedWork.modalContent.instagramPosts.length > 0 ? (
                                                    <>
                                                        <Row>
                                                            {selectedWork.modalContent.instagramPosts.map((postUrl, index) => {
                                                                // Instagram Official Embed - BEST PRACTICE ✅
                                                                // Uses Instagram's official blockquote embed method
                                                                // ✅ Supports: Reels, Videos, Images, Carousels
                                                                // ✅ Post must be public
                                                                // ✅ No downloading/reuploading - uses official embed
                                                                
                                                                // Clean URL - remove query parameters for embed
                                                                const cleanUrl = postUrl.split('?')[0];
                                                                
                                                                return (
                                                                    <Col key={index} md={6} className="mb-3 px-1">
                                                                        <div className="instagram-embed-wrapper">
                                                                            {/* Instagram Official Blockquote Embed - Empty blockquote, Instagram script will fill it */}
                                                                            <blockquote 
                                                                                className="instagram-media" 
                                                                                data-instgrm-permalink={cleanUrl}
                                                                                data-instgrm-version="14"
                                                                            >
                                                                            </blockquote>
                                                                        </div>
                                                                    </Col>
                                                                );
                                                            })}
                                                        </Row>
                                                        {selectedWork.modalContent.instagramProfile && (
                                                            <div className="text-center mt-4">
                                                                <a 
                                                                    href={selectedWork.modalContent.instagramProfile} 
                                                                    target="_blank" 
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-outline-light"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    <i className="fa-brands fa-instagram me-2"></i>
                                                                    View More on Instagram
                                                                </a>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="text-center text-white py-5">
                                                        {selectedWork.modalContent.instagramProfile ? (
                                                            <div>
                                                                <p className="mb-3">Visit our Instagram profile to see more content</p>
                                                                <a 
                                                                    href={selectedWork.modalContent.instagramProfile} 
                                                                    target="_blank" 
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-outline-light"
                                                                    style={{ textDecoration: 'none' }}
                                                                >
                                                                    <i className="fa-brands fa-instagram me-2"></i>
                                                                    View Instagram Profile
                                                                </a>
                                                            </div>
                                                        ) : (
                                                            <p>No Instagram posts available</p>
                                                        )}
                                                    </div>
                                                )}
                                            </Tab>
                                        </Tabs>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    )
};

export default OurWorks;